import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IStepProps } from '../../../common/stepper';
import { AppointmentCheckStep } from './registration-steps/appointment-check-step';
import { AppointmentSuccessStep } from './registration-steps/appointment-success-step';
import { DateStep } from './registration-steps/date-step';
import { EcpServices } from '../ecp-locator';

const baseSteps: IStepProps[] = [
  {
    id: 'appointmentDate',
    StepComponent: DateStep,
    disableBackButton: true,
    nextButtonLabel: (
      <FormattedMessage
        id="appointmentRegistration.dateStep.nextButton.label"
      />
    ),
  },
  {
    StepComponent: AppointmentCheckStep,
    disableBackButton: true,
    id: 'appointmentCheck',
    nextButtonLabel: (
      <FormattedMessage
        id="appointmentRegistration.appointmentCheckStep.nextButton.label"
      />
    ),
  },
];

const appointmentRegistrationSteps: IStepProps[] = [
  ...baseSteps,
  {
    StepComponent: AppointmentSuccessStep,
    disableBackButton: true,
    id: 'appointmentSuccess',
    nextButtonLabel: (
      <FormattedMessage
        id="appointmentRegistration.appointmentSuccessStep.nextButton.label"
      />
    ),
  },
];

export const getSteps = (ecpService: EcpServices): IStepProps[] => {
  switch (ecpService) {
    case EcpServices.aec:
    case EcpServices.cv:
      return baseSteps;
    default:
      return appointmentRegistrationSteps;
  }
};
